import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MapControls } from '../utilities/MapControls/MapConrols';
import { SocketService } from '../socket.service';
import { MatDialog } from '@angular/material';
import { decode, encode } from "@googlemaps/polyline-codec";
import { MainService } from '../services/optimizer-service/optimizer.service';
import { ActivatedRoute } from '@angular/router';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { CONSTANTS } from '../utilities/Constants';
import { HaversineFormula } from '../DataStructures/DistanceDuration/DistanceDuration';
import { UnitConverter } from '../utilities/unit-converter/UnitConverter';
import { TrackerComponent } from '../tracker/tracker.component';
import { DeliveryRatingDialogComponent } from '../delivery-rating-dialog/delivery-rating-dialog.component';
declare var google: any;
@Component({
  selector: 'app-status-update',
  templateUrl: './status-update.component.html',
  styleUrls: ['./status-update.component.css']
})
export class StatusUpdateComponent implements OnInit {

  data: any = {};
  link = null;
  d = null;
  distance = null;
  time = null;
  payload;
  driverMarkers = {

  };
  driverMap = {

  };

  @ViewChild('tracker') tracker: TrackerComponent;
  @ViewChild('map') mapReference: ElementRef;
  constructor(private dialog: MatDialog, private main: MainService, private route: ActivatedRoute, private mapControls: MapControls, private socketService: SocketService) {
  }


  ngOnInit() {

    setTimeout(() => {
      this.initializeBottomPanel();
    }, 200);
    this.link = this.route.snapshot.queryParams.l;
    this.loadInfo(true).then(() => {
      this.initializeMap().then(() => {
        this.addMarkers();
      })
      // Show delivery rating dialog if trip is completed and no rating exists
      if (this.data && this.data.state === 'COMPLETED' && !this.data.rating) {
        new QuickDialog(this.dialog).DeliveryRatingDialog({ tripid: this.data.tripid }).then(() => {
          this.loadInfo();
        });
      }
    })

  }

  getLogo() {
    if (this.payload) {
      if (this.payload.logo) {
        return this.payload.logo;
      }
    }
    return "https://tomertransport.com/assets/logo.png";
  }

  loadInfo(initialize = false) {
    return new Promise((resolve, reject) => {
      this.main.loadTrackingInfo(this.link).then((payload) => {
        this.payload = payload;
        this.data = payload;
        resolve(true);
        if (initialize) {
          this.listenForLoactionUpdates();
        }
      }).catch(e => {
        reject(false)
        console.log(e);
        new QuickDialog(this.dialog).InfoDialog(e._body, "Unable To View Location", "OK");
      })
    })
  }

  ratingClosed() {
    this.loadInfo();
  }

  addMarkers() {

    var counter = 1;
    this.payload.areas.forEach(m => {
      // Add markers to the map
      const marker1 = new google.maps.Marker({
        position: {
          lat: parseFloat(m.destinations[0].lat),
          lng: parseFloat(m.destinations[0].lng)
        },
        map: this.mapControls.map,
        title: m.address,
        icon: {
          url: `../../assets/number_${counter}.png`, // URL to your custom icon
          scaledSize: new google.maps.Size(30, 45), // Scale the icon to 50x50 pixels
        }
      });
      counter += 1;
    });

    this.drawDirections();
  }

  drawDirections() {


    var waypoints = [];
    var source = null;
    var dest = null;
    var counter = 0;
    this.payload.areas.forEach(a => {
      if (counter == 0) {
        source = {
          lat: parseFloat(a.destinations[0].lat),
          lng: parseFloat(a.destinations[0].lng)
        }
      }
      else if(counter == (this.payload.areas.length - 1)){
        dest = {
          lat: parseFloat(a.destinations[0].lat),
          lng: parseFloat(a.destinations[0].lng)
        }
      }else{
        waypoints.push({
          lat: parseFloat(a.destinations[0].lat),
          lng: parseFloat(a.destinations[0].lng)
        })
      }
      counter += 1;
    });


    this.main.rawDirections(source, dest, waypoints).then((res) => {
      this.time = new UnitConverter().secondsToFormattedTime(res.totalDuration);
      this.distance = res.totalDistance;
      var overviewPath = res.legs[0].routes[0].overview_polyline.points;
      var decoded = decode(overviewPath, 5)

      // Create a Polyline object to draw the route on the map
      var routePolyline = new google.maps.Polyline({
        path: decoded.map(x => { return { lat: x[0], lng: x[1] } }),
        strokeColor: '#3498db', // Color of the polyline
        strokeWeight: 5
      });

      routePolyline.setMap(this.mapControls.map);
      const bounds = new google.maps.LatLngBounds();

      // Extend bounds for each leg of the route
      res.legs[0].routes[0].legs.forEach(leg => {
        leg.steps.forEach(step => {
          bounds.extend(step.start_location);
          bounds.extend(step.end_location);
        });
      });

      // Adjust the map to fit the bounds
      this.mapControls.map.fitBounds(bounds);
    }).catch(e => {
      console.log(e);
    })
  }

  listenForLoactionUpdates() {
    console.log(this.tracker)
    this.socketService.connect().then(() => {
      console.log("Connected To Socket IO...");
      if (this.socketService.registerDriverLocationListener() && this.payload.allowLocation && this.payload.state == CONSTANTS.TRIP_STARTED) {
        this.socketService.onDriverLocation.subscribe((data) => {
          if (data && this.payload.state == CONSTANTS.TRIP_STARTED) {
            if (data.driverid == this.payload.driverid) {
              var location = new google.maps.LatLng(data.lat, data.lng);
              this.tracker.onLocation();
              console.log(this.tracker)
              var currentMarker = this.driverMarkers[data.driverid];
              if (currentMarker) {
                currentMarker.infowindow.setPosition({ lat: data.lat, lng: data.lng });
                currentMarker.marker.setPosition({ lat: data.lat, lng: data.lng });
                //this.mapControls.centerMapOnLoaction({ lat: data.lat, lng: data.lng });
                this.calculateDistanceTime(data.lat, data.lng);
              } else {
                this.driverMarkers[data.driverid] = this.mapControls.addSimpleDriverMarker(location, data);
              }
            }
          }
        });
      }
      if (this.socketService.registerTripUpdateListener()) {
        this.socketService.onTripUpdate.subscribe((data) => {
          this.loadInfo();
        });
      }
    }).catch(e => {
      console.log(e);
    })
  }

  calculateDistanceTime(lat, lng) {
    var dest = this.payload.area.destinations[0];
    this.distance = HaversineFormula.getDistanceFromLatLonInKm(lat, lng, dest.lat, dest.lng).toFixed(0);
    this.time = ((this.distance / 40) * 60).toFixed(0);
  }

  initializeMap() {
    return new Promise((resolve, reject) => {
      this.mapControls.initialize(this.mapReference);
      let jaLat = 18.9350138;
      let jaLng = -77.7981928;
      const mapStyles = [
        {
          featureType: "all",
          elementType: "geometry",
          stylers: [{ color: "#eaeaea" }]
        },
        {
          featureType: "poi",
          elementType: "labels.icon",
          stylers: [{ visibility: "on" }, { color: "#808080" }]
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{ color: "#808080" }]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#f1f1f1" }]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }]
        }
      ];
      this.mapControls.createMapAndCenterOnLoaction(jaLat, jaLng, true, false);
      //this.mapControls.centerMapOnCurrentPosition();
      setTimeout(() => {
        resolve(true);
      }, 1000);
    })
  }

  initializeBottomPanel() {
    const draggableElement = document.getElementById("bottomPanel");
    const draggable = document.getElementById("draggable");
    draggableElement.style.transform = `translateY(${50}%)`;
    let offsetY, isDragging = false;

    // Function to handle the start of the drag
    function startDrag(event) {
      isDragging = true;
      offsetY = (event.clientY ? event.clientY : event.touches[0].clientY) - draggableElement.getBoundingClientRect().top;
      event.preventDefault();
    }

    // Function to handle the drag movement
    function drag(event) {
      if (isDragging) {
        const y = (event.clientY ? event.clientY : event.touches[0].clientY) - offsetY;
        const maxHeight = window.innerHeight * 0.95;
        const newY = Math.min(Math.max(0, y), maxHeight);
        draggableElement.style.transform = `translateY(${newY}px)`;
      }
      event.preventDefault();
    }

    // Function to handle the end of the drag
    function endDrag() {
      isDragging = false;
    }

    // Add event listeners for drag-and-drop
    draggable.addEventListener("mousedown", startDrag);
    document.addEventListener("mousemove", drag);
    document.addEventListener("mouseup", endDrag);

    draggable.addEventListener("touchstart", startDrag);
    document.addEventListener("touchmove", drag, null);
    document.addEventListener("touchend", endDrag);

  }
}



// WEBPACK FOOTER //
// ./src/app/status-update/status-update.component.ts